<template>
  <table>
    <tbody>
      <tr>
        <td>
          <span style='font-weight: 500;margin-left: 20px'>{{$ts('System.rowDataNum')}}: </span>{{data.tableRows}}
        </td>
        <td>
          <span style='font-weight: 500;margin-left: 20px'>{{$ts('System.dataLength')}}: </span>{{data.dataLength}}
        </td>
        <td>
          <span style='font-weight: 500;margin-left: 20px'>{{$ts('System.indexLength')}}: </span>{{data.indexLength}}
        </td>
        <td>
          <span style='font-weight: 500;margin-left: 20px'>{{$ts('System.tableCreateTime')}}: </span>{{data.createTime}}
        </td>
        <td>
          <span style='font-weight: 500;margin-left: 20px'>{{$ts('System.tableUncode')}}: </span>{{data.tableCollation}}
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import i18n from '../../plugins/i18n';

export default {
  name: 'DetailTemp',
  data(){
    return {
      data:{}
    }
  },
  methods: {
    $ts(args) {
      const mes = args.split('.');
      const result = (mes[0] && mes[1] && i18n.messages[i18n.locale][mes[0]][mes[1]]) ? i18n.messages[i18n.locale][mes[0]][mes[1]] : args;
      return result;
    }
  }
}
</script>
